(function () {
  var root = document.querySelector('[data-lc-kpp]');
  var dataNode = document.getElementById('LcKidsPjsPageData');
  if (!root || !dataNode) return;

  var data = { prints: [], variants: [] };
  try {
    data = JSON.parse(dataNode.textContent) || data;
  } catch (e) {
    return;
  }

  function fileName(image) {
    return ((image && image.src) || '').split('?')[0].split('/').pop().toLowerCase();
  }

  function isGirlShot(image) {
    var file = fileName(image).replace(/\.(png|jpe?g|webp)$/, '');
    if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(file)) return true;
    if (file.indexOf('img-') === 0 || file.indexOf('img_') === 0) return true;
    if ((image.width || 0) === 1024 && (image.height || 0) === 1536) return true;
    return false;
  }

  (data.prints || []).forEach(function (print) {
    var girls = [];
    var closeups = [];
    (print.images || []).forEach(function (image) {
      if (isGirlShot(image)) girls.push(image);
      else closeups.push(image);
    });
    print.images = girls.concat(closeups);
  });

  function syncSwatchPhotos() {
    swatches.forEach(function (swatch) {
      var id = swatch.getAttribute('data-print-id');
      var print = (data.prints || []).find(function (item) {
        return item.id === id;
      });
      var img = swatch.querySelector('img');
      var girl = print && print.images && print.images[0];
      if (img && girl && girl.src) img.src = girl.src;
    });
  }

  var state = {
    printIndex: 0,
    imageIndex: 0
  };

  var titleEl = root.querySelector('[data-lc-kpp-title]');
  var countEl = root.querySelector('[data-lc-kpp-count]');
  var imageEl = root.querySelector('[data-lc-kpp-main-image]');
  var printProp = root.querySelector('[data-lc-kpp-print-prop]');
  var variantInput = root.querySelector('[data-lc-kpp-variant]');
  var prevBtn = root.querySelector('[data-lc-kpp-prev]');
  var nextBtn = root.querySelector('[data-lc-kpp-next]');
  var swatches = root.querySelectorAll('[data-lc-kpp-swatch]');
  var sizeInputs = root.querySelectorAll('[data-lc-kpp-size]');
  var loveList = root.querySelector('[data-lc-kpp-love]');
  var hero = root.querySelector('[data-lc-kpp-hero]');

  function currentPrint() {
    return data.prints[state.printIndex] || data.prints[0] || null;
  }

  function currentImages() {
    var print = currentPrint();
    return (print && print.images) || [];
  }

  function setTitles(name) {
    if (!name) return;
    if (titleEl) titleEl.textContent = name;
    if (printProp) printProp.value = name;
    var parts = (document.title || '').split(/\s[-–]\s/);
    document.title = name ? name + (parts[1] ? ' – ' + parts[1] : '') : document.title;
  }

  function renderHero() {
    var images = currentImages();
    var print = currentPrint();
    if (!images.length || !imageEl) return;
    if (state.imageIndex >= images.length) state.imageIndex = 0;
    var image = images[state.imageIndex];
    imageEl.src = image.src;
    if (image.srcset) imageEl.srcset = image.srcset;
    imageEl.sizes = '(min-width: 990px) 48vw, 100vw';
    imageEl.alt = 'Kids Pyjamas – ' + ((print && print.name) || '');
    if (countEl) countEl.textContent = images.length ? state.imageIndex + 1 + ' / ' + images.length : '';
    if (countEl) countEl.hidden = images.length < 2;
    if (prevBtn) prevBtn.disabled = images.length < 2;
    if (nextBtn) nextBtn.disabled = images.length < 2;
  }

  function renderLove() {
    if (!loveList) return;
    loveList.innerHTML = '';
    var current = currentPrint();
    var others = data.prints.filter(function (print) {
      return !current || print.id !== current.id;
    }).slice(0, 3);
    others.forEach(function (print) {
      var image = print.images && print.images[0];
      if (!image) return;
      var li = document.createElement('li');
      li.innerHTML =
        '<a class="lc-kpp__love-card" href="#print-' + print.id + '" data-lc-kpp-love-card data-print-id="' + print.id + '">' +
        '<img src="' + image.src + '" alt="' + print.name + '">' +
        '<p>' + print.name + '</p>' +
        '<p class="lc-kpp__love-price">' + (data.price || 'AED 350') + '</p>' +
        '</a>';
      loveList.appendChild(li);
    });
  }

  function findPrintIndex(id) {
    var index = data.prints.findIndex(function (print) {
      return print.id === id;
    });
    if (index >= 0) return index;
    return data.prints.findIndex(function (print) {
      return (print.images || []).some(function (image) {
        return String(image.id) === String(id);
      });
    });
  }

  function selectPrint(id, imageIndex) {
    var index = findPrintIndex(id);
    if (index < 0) return;
    state.printIndex = index;
    state.imageIndex = imageIndex || 0;
    swatches.forEach(function (swatch) {
      var on = swatch.getAttribute('data-print-id') === id;
      swatch.classList.toggle('is-selected', on);
      swatch.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var print = currentPrint();
    setTitles(print && print.name);
    renderHero();
    renderLove();
    var url = new URL(window.location.href);
    url.searchParams.set('media', id);
    history.replaceState({ lcKidsPrint: id }, '', url.toString());
  }

  function step(delta) {
    var images = currentImages();
    if (images.length < 2) return;
    state.imageIndex = (state.imageIndex + delta + images.length) % images.length;
    renderHero();
  }

  swatches.forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      selectPrint(swatch.getAttribute('data-print-id'), 0);
    });
  });

  if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

  sizeInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      sizeInputs.forEach(function (item) {
        var label = item.closest('.lc-kpp__size');
        if (label) label.classList.toggle('is-selected', item.checked);
      });
      if (variantInput) variantInput.value = input.getAttribute('data-variant-id') || variantInput.value;
    });
  });

  if (loveList) {
    loveList.addEventListener('click', function (event) {
      var card = event.target.closest('[data-lc-kpp-love-card]');
      if (!card) return;
      event.preventDefault();
      selectPrint(card.getAttribute('data-print-id'), 0);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  if (hero) {
    var startX = 0;
    hero.addEventListener('touchstart', function (event) {
      startX = event.changedTouches[0].clientX;
    }, { passive: true });
    hero.addEventListener('touchend', function (event) {
      var dx = event.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < 40) return;
      step(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  var startId = '';
  try {
    startId = new URLSearchParams(window.location.search).get('media') || '';
  } catch (e2) {}
  if (startId) {
    selectPrint(startId, 0);
  } else {
    renderHero();
    renderLove();
  }
  syncSwatchPhotos();
})();
